import React, { useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { useController } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { styled } from "@mui/material/styles";

export function AutocompleteSearchRequired({
    dataList,
    optionLabel,
    labelText,
    onChangeHanddle,
    disabled,
    required = false,
    control,
    name,
    setValue,
    rules, // prop para las reglas de validación
    defaultValue = null,
    isEmpresaPrueba = false,
}) {
    const { t } = useTranslation();
    const {
        field: { ref, ...inputProps },
        fieldState: { error },
    } = useController({
        name,
        control,
        defaultValue,
        rules: {
            ...rules, // Asegurarse de que las reglas pasadas como props se apliquen
            required: required && {
                value: true,
                message: t('login.requiredDefault'),
            },
        },
    });

    useEffect(() => {
        setValue(name, defaultValue);
    }, []);

    const onChangeHandleInner = (value) => {
        onChangeHanddle(value);
        inputProps.onChange(value);
    };


    return (
        <Autocomplete
            options={dataList}
            getOptionLabel={(option) =>
                option ? (typeof option === "string" ? option : optionLabel(option)) : ""
            }
            noOptionsText={t("AutoCompleteSearch.noHayCoincidencias")}
            onChange={(e, value) => {
                if (!onChangeHanddle) {
                    setValue(name, value);
                } else {
                    onChangeHandleInner(value);
                }
            }}
            disabled={disabled}
            sx={{ width: { sm: "100%" } }}
            value={inputProps.value}
            isOptionEqualToValue={(option, value) =>
                option.id_comunidad === value.id_comunidad
            }
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={"* "+labelText}
                    error={!!error}
                    helperText={error?.message}
                    {...inputProps}
                    sx={{
                        '& fieldset': {
                          backgroundColor: isEmpresaPrueba && "#c9c6c6",
                        },
                    }}
                />
            )}
        />
    );
}

